import { z } from 'zod';
export const uuid = z.uuid();
export const paginationQuery = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(25),
    search: z.string().trim().max(200).optional(),
    sort: z
        .string()
        .regex(/^-?[a-zA-Z_]+$/)
        .optional(),
});
/** Tipos de identificación de Hacienda (nota técnica v4.4). */
export const identificationType = z.enum(['01', '02', '03', '04']);
export const identificationTypeLabel = {
    '01': 'Cédula física',
    '02': 'Cédula jurídica',
    '03': 'DIMEX',
    '04': 'NITE',
};
const identificationLength = {
    '01': /^[1-9]\d{8}$/,
    '02': /^\d{10}$/,
    '03': /^\d{11,12}$/,
    '04': /^\d{10}$/,
};
export function isValidIdentification(type, value) {
    return identificationLength[type].test(value);
}
/** Agrega el refinamiento de cédula a un objeto que tenga identificationType + identification. */
export function withIdentificationCheck(schema) {
    return schema.superRefine((value, ctx) => {
        const v = value;
        if (!isValidIdentification(v.identificationType, v.identification)) {
            ctx.addIssue({
                code: 'custom',
                path: ['identification'],
                message: `Formato inválido para ${identificationTypeLabel[v.identificationType]}`,
            });
        }
    });
}
//# sourceMappingURL=common.js.map